import { IS_IOS } from './environmentInfo'

const copyToClipboardFactory = (window, document) => {
  if (navigator.clipboard?.writeText)
    return text => navigator.clipboard.writeText(text)

  let textArea

  const createTextArea = text => {
    textArea = document.createElement('textArea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-2000px'
    document.body.appendChild(textArea)
  }

  const selectText = () => {
    if (IS_IOS) {
      const range = document.createRange()
      range.selectNodeContents(textArea)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      textArea.setSelectionRange(0, 999999)
    } else textArea.select()
  }

  const copyTextToClipboard = () => {
    document.execCommand('copy')
    document.body.removeChild(textArea)
  }

  return text => {
    createTextArea(text)
    selectText()
    copyTextToClipboard()
  }
}

// TODO: Doesn't work in Samsung Internet
export const copyToClipboard = copyToClipboardFactory(window, document)
